"use client";

import { avenirNextDemi, fontAwesome } from '@/styles/fonts'
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import clsx from "clsx";
import { openFreeModal } from "./freeModal";
import { getEnvUrls } from '../lib/env-urls';

function NavBar(props: { isLoggedIn: boolean, isFreeUser?: boolean, positionClass?: "absolute" | "relative" }) {

  const [isMenuOpen, setMenuOpen] = useState(false);
  const menuClass = clsx(
    "relative",
    "block",
    "p-[13px]",
    "lg:float-left",
    "max-lg:pl-[0px]",
    "lg:max-lg:py-[7px]",
    "leading-[20px]",
  );

  const dashboardUrl = props.isLoggedIn
    ? (props.isFreeUser ? "/free" : getEnvUrls().paidAppUrl)
    : "/login";

  const accountButtons = <>
    <li className={clsx(menuClass, "text-white")}>
      <a href={dashboardUrl}>
        {props.isLoggedIn ? "Dashboard" : "Log in"}</a>
    </li>
    {props.isLoggedIn &&
      <li className={clsx(menuClass, "text-white")}>
        <a href="/logout">Log out</a>
      </li>
    }
    {!props.isLoggedIn &&
      <li className="lg:float-left lg:mr-[15px]">

        <Link href="/" className="block rounded-md bg-[#2da1f8] px-[20px] py-[9.5px] text-center lg:float-left mt-[4px] text-white"
          onClick={(e) => {
            e.preventDefault();
            setMenuOpen(false);
            openFreeModal();
          }}
        >Free Account</Link>
      </li>
    }
    <li className="lg:float-left lg:mr-[15px]">
      <Link href="/livedemo" className="block rounded-md bg-[#449d44] px-[20px] py-[9.5px] text-center lg:float-left mt-[4px] text-white">See a live demo</Link>
    </li>
  </>;

  /*
  opacity: .6;
  (min-width: 767px) and (max-width: 992px) {
  padding: 13px 8px;
  
  padding 13px
  */

  const menu = <>
    <li className={clsx(menuClass, "text-white opacity-60 hover:opacity-100")}>
      <Link href="/tour">Features</Link>
    </li>
    <li className={clsx(menuClass, "text-white opacity-60 hover:opacity-100")}>
      <Link href="/about_us">About Us</Link>
    </li>
    <li className={clsx(menuClass, "text-white opacity-60 hover:opacity-100")}>
      <Link href="/our_data">Our Data</Link>
    </li>
    <li className={clsx(menuClass, "text-white opacity-60 hover:opacity-100")}>
      <Link href="/pricing">Pricing</Link>
    </li>
  </>;

  return (<>
    <nav className={clsx(
      "z-40 w-full min-h-[50px] mb-[10px] static leading-[1.15] ",
      "rounded-none lg:rounded",
      "text-[16px] lg:max-lg:text-[14px]",
      "pb-[8px] sm:pb-[28px] md:pb-[35px] lg:pb-[0px]",
      "pt-[10px] lg:pt-[40px]",
      props.positionClass || 'relative',
    )}  >

      {/* Collapsable menu */}
      <div className={clsx(
        "mx-auto w-full",
        "block lg:hidden",
      )}>
        <div className={clsx(
          "lg:mx-0 max-lg:h-[50px]",
          "pl-[15px]",
          "md:px-[3%]",
          "lg:px-[5%]",
          "xl:px-[10%]",
        )}>
          <button data-target="#bs-navbar-collapse-1" data-toggle="collapse"
            onClick={() => {
              setMenuOpen(!isMenuOpen)
            }}
            aria-expanded={isMenuOpen}
            className={clsx(
              "border-[#ddd] relative float-right py-[9px] px-[10px] my-[8px] mr-[15px] border-[1px] rounded font-sans cursor-pointer text-[14px] transition-colors",
              isMenuOpen ? "bg-[#ddd] text-[#4d5760]" : "bg-transparent text-[#86939e]"
            )}
            type="button">
            Menu <span className={`${fontAwesome.className}`}>
              &#xf0c9;</span> { /* ☰ <i className="fa fa-bars"></i> */}
          </button>

          <Link href="/" className="float-left h-[50px]
                py-[11px] pr-[15px] lg:py-[7px]">
            <Image src="/public/images/adbeat-logo.svg"
              width={90} height={22}
              alt="Adbeat logo" />
          </Link>
        </div>

        <div id="bs-navbar-collapse-1" className={clsx(
          "max-lg:px-[2%]",
          "md:pr-[3%]",
          "lg:pr-[5%]",
          "xl:pr-[10%]",
          avenirNextDemi.className,
          "w-full lg:w-auto",
          "lg:mx-0 border-[#e7e7e7] lg:pb-[0px] px-[15px] ",
          "max-lg:bg-[#13172c] max-lg:rounded-b")}
          style={{
            transition: "all 0.3s ease-in-out",
            maxHeight: isMenuOpen ? "1000px" : "0px",
            overflow: "hidden",
            paddingBottom: isMenuOpen ? "15px" : "0px",
          }}
        >
          <ul className="w-full lg:w-auto lg:float-left">
            {menu}
          </ul>
          <ul className="w-full lg:w-auto lg:float-right">
            {accountButtons}
          </ul>
        </div>
      </div>

      {/* Full menu */}
      <div className={clsx(
        "mx-auto w-full max-w-[1650px]",
        "block max-lg:hidden",
      )}>
        <div className={clsx(
          "lg:mx-0 max-lg:h-[50px]",
          "px-[2%]",
          "md:px-[3%]",
          "lg:px-[5%]",
          "xl:px-[10%]",
        )}>
          <Link href="/" className="float-left h-[50px]
                py-[11px] pr-[15px] lg:py-[7px]">
            <Image src="/public/images/adbeat-logo.svg"
              width={90} height={22}
              alt="Adbeat logo" />
          </Link>
        </div>

        <div id="bs-navbar-collapse-1" className={clsx(
          "max-lg:px-[2%]",
          "md:pr-[3%]",
          "lg:pr-[5%]",
          "xl:pr-[10%]",
          avenirNextDemi.className,
          "w-full lg:w-auto",
          "lg:mx-0 border-[#e7e7e7] lg:pb-[0px] px-[15px] ",
          "max-lg:bg-[#13172c] max-lg:rounded-b")}
        >
          <ul className="w-full lg:w-auto lg:float-left">
            {menu}
          </ul>
          <ul className="w-full lg:w-auto lg:float-right">
            {accountButtons}
          </ul>
        </div>
      </div>
    </nav>

  </>

  );
}

export default NavBar;